var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"columns":_vm.columnsExpand,"data":_vm.row.salesOrders,"stripe":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }